import { z } from 'zod'

export const UserRegistrationPayload = z.object({
    email: z.string().email(),
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    password: z.string().min(1),
    card_id: z.string().optional(),
    manager_name: z.string().optional(),
    client: z.string().optional(),
    service: z.string().optional(),
})

export type UserRegistrationPayload = z.infer<typeof UserRegistrationPayload>

export const AccountActivationPayload = z.object({
    manager: z.string(),
    token: z.string(),
    password: z.string().optional(),
})

export type AccountActivationPayload = z.infer<typeof AccountActivationPayload>
